import React from 'react';
import styles from '../../../styles/usageRights.module.css';
import CustomSelect from '../../common/CustomSelect/CustomSelect';
import FilterDropDown from './FilterDropDown';
import FilterLabel from './FilterLabel';

function UsageRightHeader() {
  return (
    <div className={styles.usageRightsHeader}>
      <span className={styles.usageRightsHeaderText}>Requests Received</span>
      <div className={styles.usageRightsHeaderRightContainer}>
        <CustomSelect
          selectLabel={<FilterLabel />}
          dropDownElement={(setOpened) => <FilterDropDown setOpened={setOpened} />}
        />
      </div>
    </div>
  );
}

export default UsageRightHeader;
